<template>
  <Multiselect
    v-model="internalValue"
    :options="options"
    :label="label"
    :multiple="!isSingleSelect"
  />
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Filter } from '~/components/products/ProductFilter.vue'
import type { Option } from '~/components/inputs/Multiselect.vue'
import type { Schemas } from '#shopware'

const { t } = useI18n()

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  isCategoryFilter: {
    type: Boolean,
    default: false,
  },
  isSingleSelect: {
    type: Boolean,
    default: false,
  },
  propertyOptions: {
    type: Object as PropType<Filter>,
    default: () => ({}),
  },
  categoryOptions: {
    type: Array as PropType<Schemas['Category'][]>,
    default: () => [],
  },
})

const value = defineModel<string[]>()

const internalValue = computed({
  get: () => {
    if (props.isSingleSelect) {
      return value.value[0] ?? ''
    }
    return value.value
  },
  set: (newVal) => {
    if (props.isSingleSelect) {
      value.value = newVal ? [newVal] : []
    } else {
      value.value = newVal
    }
  },
})

const label = computed(() => props.label || props.propertyOptions?.label)

const options = computed<Option[]>(() => {
  if (props.isCategoryFilter) {
    const categoryOptions = props.categoryOptions.map((category) => {
      return {
        value: category.id,
        label: getTranslatedProperty(category, 'name'),
        optionsLabel: getTranslatedProperty(category, 'name'),
      }
    })

    if (props.isSingleSelect) {
      categoryOptions.unshift({
        value: '',
        label: props.label,
        optionsLabel: t('all'),
      })
    }

    return categoryOptions
  }

  return props.propertyOptions.options.map((entity) => {
    return {
      value: entity.id,
      label: getTranslatedProperty(entity, 'name'),
      optionsLabel: getTranslatedProperty(entity, 'name'),
    }
  })
})
</script>
